import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { BlogRoutingModule } from './blog-routing.module';
import { BlogComponent } from './blog/blog.component';
import { PaginaComponent } from './blog/pagina/pagina.component';

import { FilterPipe } from './blog/filter.pipe';

//Pagination
import { NgxPaginationModule } from 'ngx-pagination';
import { MatchesCategoryPipe } from './blog/matches-category.pipe';
import { CategoriasComponent } from './categorias/categorias.component';
import { DetalleComponent } from './categorias/detalle/detalle.component';
import { TituloComponent } from './titulo/titulo.component';
import { FormsModule } from '@angular/forms';
import { SearchFilterPipe } from '././blog/search-filter.pipe';
import { SearchResultsComponent } from './search-results/search-results.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, '../../../assets/i18n/', '.json');
}

@NgModule({
  declarations: [BlogComponent, PaginaComponent, FilterPipe, MatchesCategoryPipe, CategoriasComponent, DetalleComponent, TituloComponent,SearchFilterPipe, SearchResultsComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    BlogRoutingModule,
    NgxPaginationModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  })
  ]
})
export class BlogModule { }
